import snakeCase from 'lodash/snakeCase';

const SORT_STRING_SEPARATOR = ',';

const screamingSnakeCase = str => snakeCase(str).toUpperCase();

const parseSortStr = (str) => {
  if (!str) return null;
  const sort = str.split(SORT_STRING_SEPARATOR);
  let field = sort[0];
  if (!field) return null;
  field = screamingSnakeCase(field);
  const direction = screamingSnakeCase(sort[1]);
  return { field, direction };
};

const buildSortStr = (field, direction) =>
  [field, direction].join(SORT_STRING_SEPARATOR);

export default (mixinOptions = {}) => {
  const useInternalSort = mixinOptions.useInternalSort || false;

  return {
    data() {
      return {
        internalSort: null,
      };
    },
    computed: {
      sortString() {
        if (useInternalSort) return this.internalSort;
        return this.$route.query.sort;
      },
      sortInfo() {
        return parseSortStr(this.sortString) || mixinOptions.defaultSort;
      },
    },
    methods: {
      resetInternalSort() {
        this.internalSort = null;
      },
      sortBy({ field, direction }) {
        const sort = buildSortStr(field, direction);
        if (useInternalSort) {
          this.internalSort = sort;
        } else {
          const query = { ...this.$route.query, sort };
          this.$router.push({ query });
        }
      },
    },
  };
};



// WEBPACK FOOTER //
// ./mixins/SortedView.js